module.exports = __webpack_public_path__ + "static/img/img_verifcode.3ce0f449.png";